export const CCProvider = {
  ADLS2: 'adls2',
  GCS: 'gs',
  S3: 's3',
} as const;
export type CCProviderE = typeof CCProvider[keyof typeof CCProvider];
export type CCProviderK = keyof typeof CCProvider;

export default CCProvider;
